import { render, staticRenderFns } from "./Mantenimientos.vue?vue&type=template&id=1198801c"
import script from "./Mantenimientos.vue?vue&type=script&lang=js"
export * from "./Mantenimientos.vue?vue&type=script&lang=js"
import style0 from "./Mantenimientos.vue?vue&type=style&index=0&id=1198801c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports